import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
const NAMES = ['María L.', 'Sofía G.', 'Valentina R.', 'Camila M.', 'Lucía P.', 'Martina S.', 'Julieta F.', 'Paula B.', 'Ana C.', 'Carmen D.', 'Isabella R.', 'Gabriela M.', 'Patricia S.', 'Elena V.', 'Rosa T.'];
const COUNTRIES = ['España', 'México', 'Colombia', 'Perú', 'Chile', 'Argentina', 'Venezuela', 'Ecuador', 'Costa Rica', 'Bolivia', 'Uruguay', 'Paraguay', 'Brasil', 'Guatemala', 'Honduras'];
export function NotificationPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    country: ''
  });
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 5000);
    const interval = setInterval(() => {
      showNotification();
    }, 15000 + Math.random() * 10000); // Random interval between 15-25s
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  const showNotification = () => {
    const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
    const randomCountry = COUNTRIES[Math.floor(Math.random() * COUNTRIES.length)];
    setData({
      name: randomName,
      country: randomCountry
    });
    setIsVisible(true);
    // Hide after 5 seconds
    setTimeout(() => {
      setIsVisible(false);
    }, 5000);
  };
  return <AnimatePresence data-id="element-83">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: 0
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 z-50 max-w-sm cursor-pointer" onClick={() => setIsVisible(false)} data-id="element-84">
          <div className="bg-white rounded-xl shadow-2xl p-4 border-l-4 border-green-500 flex items-center gap-4 ring-1 ring-black/5" data-id="element-85">
            <div className="bg-green-100 p-2.5 rounded-full flex-shrink-0" data-id="element-86">
              <CheckCircle className="w-6 h-6 text-green-600" data-id="element-87" />
            </div>
            <div data-id="element-88">
              <p className="text-sm font-medium text-gray-900" data-id="element-89">
                <span className="font-bold" data-id="element-90">{data.name}</span> de {data.country}
              </p>
              <p className="text-xs text-gray-500 mt-0.5" data-id="element-91">
                acaba de comprar{' '}
                <span className="font-semibold text-gray-700" data-id="element-92">
                  PACK INGLÉS LISTO™
                </span>
              </p>
              <p className="text-[10px] text-gray-400 mt-1" data-id="element-93">
                Hace unos instantes
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}